import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { useParams } from "react-router-dom";
import { Documents } from ".";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";

interface PerStatus {
  statusCount: string;
  status: string;
}

export const ChartBar = ({ data }: Documents) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const labelsOrder = [
    "Pendente",
    "Agendado",
    "A caminho",
    "Chegou",
    "Abortada",
    "Entregue",
    "Não Entregue",
    "Coletado",
    "Não Coletado",
    "Transferido",
  ];
  const [dataChart, setDataChart] = useState<number[]>([]);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    const stCode: string[] = [];
    const stQtd: number[] = [];
    const sizes = getSizesComponent({ id: "chart-status-documents" });
    labelsOrder.map((status) => {
      const obj = data.perStatus.find(
        (elem: PerStatus) => elem.status === status
      );
      if (obj) {
        stCode.push(obj.status);
        stQtd.push(parseInt(obj.statusCount));
      } else {
        stCode.push(status);
        stQtd.push(0);
      }
    });
    if (stQtd && stQtd.length !== 0) {
      const fakesCol = Math.floor(sizes.height / stQtd.length / 230);

      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          stQtd.push(0);
        }
      }
    }
    setLabels(stCode);
    setDataChart(stQtd);
  }, [data]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-status-documents" });
    if (dataChart && dataChart.length !== 0) {
      setTotal(
        dataChart.reduce(function (soma: number, i: number) {
          return +soma + +i;
        })
      );
    }

    if (sizes.width < 345) {
      setFontSize({ id: "chart-status-documents", width: sizes.width });
    }
    if (dataChart && dataChart.length > 10) {
      if (sizes.height > dataChart.length * 32) {
        setHeightChart(sizes.height - 40);
      } else {
        setHeightChart(dataChart.length * 35);
      }
    } else {
      setHeightChart(sizes.height - 40);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [dataChart]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          let status = "";
          switch (labelsOrder[config.dataPointIndex]) {
            case 'Pendente':
              status = "0";
              break;
            case 'Agendado':
              status = "15";
              break;
            case "A caminho":
              status = "1";
              break;
            case "Chegou":
              status = "2";
              break;
            case "Abortada":
              status = "7";
              break;
            case "Entregue":
              status = "3,4";
              break;
            case "Não Entregue":
              status = "6";
              break;
            case "Coletado":
              status = "8";
              break;
            case "Não Coletado":
              status = "9";
              break;
            case "Transferido":
              status = "17";
              break;
          }
          if (
            mode === "view" &&
            componentProperty({
              id: "chartStatusDocuments",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartStatusDocuments", {
                redirectTowerToIndex: true,
                date: true,
                dueRouteDate: 'dateR',
                status_stop_id: status
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: [
      "#808080",
      "#8105aa",
      "#ffc125",
      "#0353ac",
      "#663399",
      "#006400",
      "#ff0000",
      "#006400",
      "#ff0000",
      "#006400",
    ],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        if (labels[opt.dataPointIndex]) {
          return labels[opt.dataPointIndex] + ":  " + val;
        }
        return "";
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };
  const series = [
    {
      data: dataChart,
    },
  ];

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Documentos por Status: Você tem ${total} documentos hoje`}
        clickable={componentProperty({
          id: "chartStatusDocuments",
          property: "redirect",
        })}
        id="chart-status-documents"
      />
      <div
        id={
          dataChart &&
          (dataChart.length <= 10 ||
            getSizesComponent({ id: "chart-status-documents" }).height >
              dataChart.length * 32)
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
